
  import { defineComponent, defineAsyncComponent, markRaw } from 'vue';
  import MainHeaderComponent from '../components/Main-header/MainHeaderComp.vue';
  import AnchorMenuComponent from "@/components/Mod/AnchorMenuComp.vue";
  import DownloadComponent from "@/components/Mod/DownloadComp.vue";
  import Api from '@/common/mods';
  import {createErrorChain} from "@/services/ErrorHandler";
  import type ResponseType from "@/types/IResponse";
  import {ModType} from "@/types/IModData";
  import { Head } from '@unhead/vue/components'
  import DataMixins from "@/mixins/DataMixins";
  import ModsArchiveComponent from "@/components/Mod/ModsArchiveComp.vue";
  import CarouselPreviewComponent from "@/components/Mod/CarouselPreviewComp.vue";
  import LikeButtonComponent from "@/components/Mod/LikeButtonComp.vue";
  import InstructionsMixins from "@/mixins/InstructionsMixins";
  import ModTitleComponent from "@/components/Mod/ModTitleComp.vue";
  import ModTitlePreloaderComponent from "@/components/Mod/ModTitlePreloaderComp.vue";
  import {useHead} from "@unhead/vue";
  import CarBadge from "@/services/CarBadgeService";

  interface State {
    modData: ModType
    preloaderShow: boolean
    SimilarCards: any
    CommentsWrapper: any
    VideoComp: any
    CarouselComp: any
  }

  export default defineComponent({
    name: 'ModView',
    components: {
      ModTitlePreloaderComponent,
      ModTitleComponent,
      LikeButtonComponent,
      CarouselPreviewComponent,
      ModsArchiveComponent,
      DownloadComponent,
      AnchorMenuComponent,
      MainHeaderComponent,
      Head
    },
    data: (): State => ({
      modData: {
        author: '',
        category: '',
        description: '',
        downloads: 0,
        game: '',
        id: 0,
        likes: 0,
        timestamp: '',
        title: '',
        views: 0,
        images: [],
        tags: [],
        video: '',
        actual_version: {
          timestamp: '',
          id: 0,
          size: '',
          version: ''
        },
        archive_versions: []
      },
      preloaderShow: true,
      SimilarCards: null,
      CommentsWrapper: null,
      CarouselComp: null,
      VideoComp: null
    }),
    mixins: [DataMixins, InstructionsMixins],
    methods: {
      likeMod() {
        this.modData.likes++;
      },
      uploadMod(slug: any) {
        return new Promise((resolve: any) => {
          Api.getModBySlug({ slug: slug, l: undefined}, (res: ResponseType) => {
            this.modData = res.data;
            this.loadSimilarCards();
            this.loadCommentsWrapper();
            this.loadCarouselComponent();

            /*
            ВИДЕО БЛОК -- Здесь насрано
             */
            if(res.data.video != null) {
              this.loadVideoComponent();
            } else {
              this.VideoComp = null
            }
            resolve();
          }, (err: any) => {
            if(err.response.status === 404) {
              this.$router.push({name: '404'})
            }
          });
        });
      },
      async loadSimilarCards() {
        // Динамически импортируемый компонент SimilarCardsComponent
        this.SimilarCards = markRaw(defineAsyncComponent(() =>
            import("@/components/Cards-wrapper/SimilarCardsComp.vue")
        ));
      },
      async loadCommentsWrapper() {
        // Динамически импортируемый компонент CommentsWrapperComponent
        this.CommentsWrapper = markRaw(defineAsyncComponent(() =>
            import("@/components/Comments/CommentsWrapperComp.vue")
        ));
      },
      async loadVideoComponent() {
        // Динамически импортируемый компонент ModVideoComponent
        this.VideoComp = markRaw(defineAsyncComponent(() =>
            import("@/components/Mod/ModVideoComp.vue")
        ));
      },
      async loadCarouselComponent() {
        // Динамически импортируемый компонент CarouselComponent
        this.CarouselComp = markRaw(defineAsyncComponent(() =>
            import("@/components/Mod/CarouselComp.vue")
        ));
      }
    },
    computed: {
      carMarkBadge() {
        const carBadge = new CarBadge(this.modData.title);
        return carBadge.findCarBrand();
      },
      metaTitle() {
        const vers = this.modData.actual_version.version ? this.modData.actual_version.version : '',
            game = this.modData.game ? this.getPrettyGame(this.modData.game) : '',
            title = this.modData.title ? this.modData.title : ''

        return `Скачать мод ${title} (${vers}) для игры ${game} - Modbox`
      },
      metaDesc() {
        const vers = this.modData.actual_version.version ? this.modData.actual_version.version : '',
            game = this.modData.game ? this.getPrettyGame(this.modData.game) : '',
            title = this.modData.title ? this.modData.title: '',
            category = this.modData.category ? this.getPrettyCategory(this.modData.category) : ''

        return `Мод на ${category.toLowerCase()} ${title} (${vers}), здесь вы можете быстро скачать качественные моды для игры ${game} без вирусов`
      },
    },
    beforeRouteUpdate(to: any, from: any, next: any) {
      if (to.params.slug !== from.params.slug) {
        this.preloaderShow = true;
        this.uploadMod(to.params.slug).then(() => {
          this.preloaderShow = false;
          next();
        });
      } else {
        next();
      }
    },
    created() {
      this.uploadMod(this.$route.params.slug).then(() => {
        this.preloaderShow = false;
      })
    },
    setup() {
      useHead({
        meta: [
          {
            name: 'charset',
            content: 'utf-8'
          },
          {
            name: 'theme-color',
            content: '#fff'
          },
          {
            name: 'og:type',
            content: 'article'
          },
          {
            name: 'og:site_name',
            content: 'Моды для Assetto Corsa, BeamNG Drive - Mod-Box.ru'
          }
        ],
      });
    },
    mounted() {
      Api.incrementModViews({slug: this.$route.params.slug}, (res: ResponseType) => {
        this.modData.views = res.data["views"]
      }, (err: any) => {
        const properties = ['slug']

        const errorHandler = createErrorChain(properties, (msg: string[]) => {
          console.error(msg.pop())
        })

        errorHandler.handle(err)
      });
    }
  });
